import { Helmet, HelmetProvider } from 'react-helmet-async';

// This file ensures react-helmet-async is properly included in the bundle
// and provides a simple way to use it consistently throughout the app

// Export the components directly
export { Helmet, HelmetProvider };

// Create a singleton helmetContext to be used app-wide
export const helmetContext = {};

// Initialize the helmet provider
export const initHelmet = () => {
  // Force the module to be included in the bundle
  if (typeof Helmet === 'undefined' || typeof HelmetProvider === 'undefined') {
    console.error('Helmet or HelmetProvider is undefined');
  }
  
  return { Helmet, HelmetProvider, helmetContext };
};

// Call the initialization to ensure the module is loaded
initHelmet(); 